import { styled, Theme } from "@mui/material/styles";

const LabeledFieldset = styled("fieldset")(({ theme }: { theme: Theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  margin: 0,
  padding: 0,
  transition: "border-color .2s",
  "& legend": {
    padding: `0 ${theme.spacing(1)}`,
    fontSize: "0.75rem",
    color: theme.palette.text.secondary,
    marginLeft: 5,
    transition: "color .2s",
  },
  "&:focus-within": {
    borderColor: theme.palette.primary.main,
    borderWidth: "2px",
    marginLeft: "-1px",
    "& legend": { color: theme.palette.primary.main },
  },
}));

export default LabeledFieldset;
